import { z } from 'zod';
import { filterItemSchema } from '@/lib/parsers';

const weekParamsSchema = z.object({
  year: z.union([z.number(), z.null()]).refine((v) => v !== null, {
    error: 'selectSuppliersAndWeeksToCreateLotSizing',
  }),
  week: z.union([z.number(), z.null()]).refine((v) => v !== null, {
    error: 'selectSuppliersAndWeeksToCreateLotSizing',
  }),
  endYear: z.number().nullable(),
  endWeek: z.number().nullable(),
  page: z
    .number()
    .nullish()
    .transform((v) => v ?? 1),
});

export const createLotSizingFormSchema = z
  .object({
    weekParams: weekParamsSchema,
    filters: z.array(filterItemSchema),
  })
  .superRefine((data, ctx) => {
    const supplierFilter = data.filters.find((f) => f.id === 'supplierId');
    const count = Array.isArray(supplierFilter?.value)
      ? supplierFilter.value.length
      : 0;
    if (count < 1 || count > 3) {
      ctx.addIssue({
        code: 'custom',
        message: 'selectSuppliersAndWeeksToCreateLotSizing',
        path: ['filters'],
      });
    }
  });

export type CreateLotSizingFormValues = z.input<
  typeof createLotSizingFormSchema
>;

export type CreateLotSizingFormOutput = z.output<
  typeof createLotSizingFormSchema
>;
